import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import RestService from "./../../Restservice";
import Faq from "react-faq-component";
import Common from "./../../common.json";

export default function FAQ() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState({});

  useEffect(() => {
    setLoading(true);
    RestService.getFAQData(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setglobaldata(response.data);
    });
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet {...Common?.faq} />

      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="FAQ" />
          <div className="signalheader">
            <div className="news-original">
              <div className="row">
                <div className="col-md-12 w3ls_mutual_funds_grid1_jkjk">
                  <div className="agileits_about_grids w3ls_products_grid">
                    <div className="agileits_about_grid">
                      <div className="col-md-12 agileits_about_grid_right faq-list">
                        <Faq data={globaldata.response} />
                      </div>

                      <div className="clearfix"> </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix"> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
